// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"21ee6d35","745":"e7ad66ae"}[chunkId] + ".chunk.js";
};